import { ThemeId } from "../../../../../styles/types/theme.js";
const DEFAULT_ICON = 'nico-angle-right';
export const ICON = {
    [ThemeId.veci]: 'nico-angle-right-heavy'
};
export const tabIcon = (theme)=>{
    if (theme in ICON) return ICON[theme];
    return DEFAULT_ICON;
};

//# sourceMappingURL=index.js.map